import { useEffect, useState, useCallback } from "react"

interface ConfettiProps {
  trigger: boolean
  onComplete?: () => void
}

interface Particle {
  id: number
  x: number
  color: string
  delay: number
}

const CONFETTI_COLORS = [
  "oklch(0.623 0.214 259.815)", // primary
  "oklch(0.55 0.25 265)", // gradient-start
  "oklch(0.60 0.28 300)", // gradient-end
  "oklch(0.72 0.19 142)", // success
  "oklch(0.82 0.17 84)", // warning
]

export function Confetti({ trigger, onComplete }: ConfettiProps) {
  const [particles, setParticles] = useState<Particle[]>([])

  const handleComplete = useCallback(() => {
    onComplete?.()
  }, [onComplete])

  useEffect(() => {
    if (trigger) {
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        delay: Math.random() * 0.5,
      }))
      setParticles(newParticles)

      const timer = setTimeout(() => {
        setParticles([])
        handleComplete()
      }, 2000)

      return () => clearTimeout(timer)
    }
  }, [trigger, handleComplete])

  if (particles.length === 0) return null

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999] overflow-hidden">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute h-2 w-2 rounded-full animate-[confetti_2s_ease-out_forwards]"
          style={{
            left: `${particle.x}%`,
            top: "50%",
            backgroundColor: particle.color,
            animationDelay: `${particle.delay}s`,
          }}
        />
      ))}
    </div>
  )
}
